import { Icon, ProgressBar } from '@hai/ui-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatBytes } from 'src/js/helper/duration-format-helper';
import { StorageModel } from './storage-model';

export type StorageUsageHeaderProps = {
  storage: StorageModel;
  useThresholdColors?: boolean;
};

export const StorageUsageHeader = ({ storage, useThresholdColors = false }: StorageUsageHeaderProps) => {
  const { t } = useTranslation();

  const total = storage?.total;
  const free = storage?.free;
  const diskSpaceUsed = total ? total - (free ?? 0) : 0;
  const diskUsagePct = total ? (diskSpaceUsed / total) * 100 : 0;
  const diskCapacityGB = total ? (total / (1024 * 1024 * 1024)).toFixed(2) : 0;
  const diskUsage = total
    ? `${formatBytes(diskSpaceUsed)} ${t('general.of')} ${diskCapacityGB} ${t(
        'general.gbused',
      )} (${diskUsagePct.toFixed(2)}%)`
    : '';

  let sliderValue = Math.floor(diskUsagePct);
  let sliderColor: string | undefined;

  if (useThresholdColors) {
    if (sliderValue >= 100) {
      sliderValue = 99.99999;
      sliderColor = '#da4649';
    } else if (sliderValue >= 85) {
      sliderColor = '#f5be32';
    }
  }

  return (
    <div className="assets-file-explorer-header mt-4 flexVerticalCenter recordingWidgetHeader">
      <div>
        <Icon iconname="Database" color="haiui-gray-07" size="sm" />
      </div>
      <div className="spaceBetween">
        <div className="verticalStack leftSectionMinimal">
          <span className="fontMedLight">{t('assets.widget.internalStorage')}</span>
          <span className="fontTinyGray hai-gray-06">{storage?.path ?? '\u00A0'}</span>
        </div>
        <ProgressBar
          hideRight={true}
          label={
            <div className="spaceBetween">
              <span className="fontMedLight"> </span>
              <span className="fontTinyGray hai-gray-06">{diskUsage}</span>
            </div>
          }
          value={sliderValue}
          maxValue={100}
          barColors={{ background: '#35363e', right: sliderColor ?? '#525362', left: sliderColor ?? '#525362' }}
        />
      </div>
    </div>
  );
};
